/** tm/pages/MobileNote.tsx — 휴대폰에서 현장 노트 바로 적기 (/m · 2026-11-01 지도사 「현장에서 얻은 아이디어 · 배운 점」)
 *  배운 점 / 서비스 아이디어 고르고 한 칸에 적기 → 저장. 정리(반영할 곳 · 상태 · 찾기)는 PC 「현장 노트」에서 */
import { useState } from 'react';
import * as N from '../api-notes';
import type { NoteKind } from '../api-notes';
import { Button, Chips, Field, SaveBar, guard, input } from './mobileKit';

export default function MobileNote({ toast, onSaved }: { toast: (m: string) => void; onSaved: () => void }) {
  const [kind, setKind] = useState<NoteKind>('idea');
  const [text, setText] = useState('');
  const [who, setWho] = useState('');
  const [busy, setBusy] = useState(false);
  const save = async () => {
    if (!guard(text.trim() ? '' : '적을 내용을 넣어 주세요', busy, toast)) return;
    setBusy(true);
    try {
      await N.createNote(kind === 'idea' ? { kind, scene: text.trim(), source_person: who.trim() } : { kind, body: text.trim(), source_person: who.trim() });
      toast(kind === 'idea' ? '아이디어를 적어 뒀어요 · PC 「현장 노트」에서 정리' : '배운 점을 적어 뒀어요');
      setText(''); setWho(''); onSaved();
    } catch (e) { toast((e as Error).message); } finally { setBusy(false); }
  };
  return (
    <>
      <Field title="무엇을 적나요">
        <Chips cols={2} items={[{ k: 'idea', t: '서비스 아이디어' }, { k: 'learn', t: '배운 점' }]} value={[kind]} onChange={(v) => setKind((v[0] as NoteKind) || 'idea')} />
      </Field>
      <Field title={kind === 'idea' ? '현장에서 들은 것' : '배운 점'} need>
        <textarea value={text} onChange={(e) => setText(e.target.value)} rows={6} maxLength={2000}
          placeholder={kind === 'idea' ? '예: 팀장님이 업체에 해 드린 일을 한 장으로 들고 나가고 싶어 하심' : '예: 제조 대표님은 금리보다 한도 · 속도를 먼저 물으심'}
          style={{ ...input, height: 'auto', minHeight: 160, padding: '14px', lineHeight: 1.6, resize: 'vertical' }} />
      </Field>
      <Field title="알려 준 분" note="비워도 돼요">
        <input value={who} onChange={(e) => setWho(e.target.value)} maxLength={60} placeholder="예: 최은연 팀장님" style={input} />
      </Field>
      <SaveBar><Button onClick={() => void save()} muted={!text.trim()}>{busy ? '저장 중…' : '저장'}</Button></SaveBar>
    </>
  );
}
